import { render, staticRenderFns } from "./ProfileNavMenu.vue?vue&type=template&id=d4b07fc8&"
import script from "./ProfileNavMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNavMenu.vue?vue&type=style&index=0&id=d4b07fc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports